import { createContext, useContext, useState, useCallback } from "react";

const KEY = "alphaapeing_global_age";

// value is either "all" or a positive number of hours (as a string, e.g. "6").
export const normalizeAge = (v) => {
  if (!v || v === "all") return "all";
  const n = parseFloat(String(v).replace(/h$/i, ""));
  return Number.isFinite(n) && n > 0 ? String(n) : "all";
};

const Ctx = createContext(null);

export const AgeFilterProvider = ({ children }) => {
  const [age, setAgeState] = useState(() => normalizeAge(localStorage.getItem(KEY)));
  const setAge = useCallback((v) => {
    const next = normalizeAge(v);
    setAgeState(next);
    localStorage.setItem(KEY, next);
  }, []);
  return <Ctx.Provider value={{ age, setAge }}>{children}</Ctx.Provider>;
};

export const useGlobalAge = () => useContext(Ctx);
